import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=c922386c&scoped=true&"
import script from "./AddQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestion.vue?vue&type=style&index=0&id=c922386c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c922386c",
  null
  
)

export default component.exports